import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/shared-components';

import style from './style.module.scss';

export function NoButton(props) {
  const className = `${props.className}  ${style.noButton}`;
  return (
    <Button
      className={className}
      tabIndex={props.tabIndex}
      onClick={props.onClickNo}>
      No
    </Button>
  );
}

NoButton.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
  /**
   * callback function for button press no
   */
  onClickNo: PropTypes.func.isRequired,
  /**
   * for keyboard accesibility
   */
  tabIndex: PropTypes.number,
};

NoButton.defaultProps = {
  className: '',
};
